import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup, FormArray, FormControl } from '@angular/forms';
import { ObjetivoService } from '../../../services/objetivo.service';
import { AmbienteService } from 'src/app/modulos/catalogos-admin/services/ambiente.service';
import { EstrategiaObjetivoService } from '../../../services/estrategia-objetivo.service';
import { EstrategiasService } from '../../../services/estrategias.service';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { AlertService } from 'src/app/services/alert.service';
import { forkJoin, map } from 'rxjs';
import { AniosObjetivosService } from 'src/app/modulos/catalogos-admin/services/anios-objetivos.service';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { ConstantsCatalogosIdService } from '../../../../../services/constants-catalogos-id.service';
import { Ambiente } from 'src/app/modulos/catalogos-proces/models/ambiente';



@Component({
  selector: 'app-objetivos-estrategias-superior',
  templateUrl: './objetivos-estrategias-superior.component.html',
  styleUrls: ['./objetivos-estrategias-superior.component.css']
})
export class ObjetivosEstrategiasSuperiorComponent {

  public submitted = false;
  public formObjetivo!: UntypedFormGroup;
  public formEstrategia!: UntypedFormGroup;
  public desripcionObjetivo!: any;
  public idSprObjetivoA!: any;
  public dataObjetivoNivelSuperior!: any;
  public dataAmbiente!: any;
  public dataEstrategiaObjetivoMain: any = [];
  public dataEstrategias: any = [];
  private ipAddress!: string;
  public idSprAmbiente!: number;
  private currentUser!: any;
  private buffer!: any;
  public nombreUnidad!: any;
  public estraregiasObjetivoSeleccionado = []
  public estrategiasBorrar = []
  public deshabilitarEditar: boolean = true
  public dataPlanAnios: any = [];
  public idAnio: any;
  public dataObjetivosAnios: any = [];
  idSprPlanAnio:number = 0;
  idSprNivel:number = 0;
  public ambienteNivelSuperior: Ambiente

  @Input() set msgEstrategiaSup(data: any) {
    this.getIpPublic();
    this.initApp(data);
  }
  readonly constant = ConstantsCatalogosIdService;
  constructor(
    private fb: FormBuilder,
    private objetivosService: ObjetivoService,
    private ambienteService: AmbienteService,
    private alert: AlertService,
    private ip: IpPublicService,
    private estrategiaObjetivoService: EstrategiaObjetivoService,
    private estrategiasService: EstrategiasService,
    private aniosObjetivosService: AniosObjetivosService,
    private store: Store<AppState>,
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.nombreUnidad = this.currentUser.nombreUnidad;
    //this.idSprAmbiente = this.currentUser.idSprAmbiente;
  }

  get EstrategiasForm() {
    return this.formEstrategia.controls;
  }

  ngOnInit(){
    this.store.select('globalApp').subscribe((response) => {
      // redux
      this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio;
      this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
      this.idSprNivel =  response.ambienteSeleccionado.nivel.idSprNivel;
    });
  }

  initApp(data: any) {
    this. setForm();
    if (data.name == 'estrategia-sup') {
      this.dataObjetivosAnios = [];
      //this.getDataApp();
      this.getEstrategiasObjetivo(data.idSprObjetivo)
      this.listAmbiente();
    }
    this.idSprObjetivoA = data.idSprObjetivo;
    this.setFormAlineacionEs();
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  habilitarEditar() {
    this.deshabilitarEditar = false
  }

  getEstrategiasObjetivo(idSprObjetivo: number) {
    this.estrategiaObjetivoService.list('?idSprObjetivo=' + idSprObjetivo).subscribe(res => {
      this.estraregiasObjetivoSeleccionado = res.map(estrategia => {
        return {
          "idSprEstrategia": estrategia.idSprEstrategia,
          "idSprEstrategiaObjetivo": estrategia.idSprEstrategiaObjetivo
        }
      })

    })
  }

  verifyChecked(estrategia: any, estrategiasSeleccionadas: any[]): boolean {
    return estrategiasSeleccionadas.some(obj => obj.idSprEstrategia === estrategia.idSprEstrategia)
  }

  setForm() {
    this.formObjetivo = this.fb.group({
      idSprAtribucionObjetivo: [],
      idSprAtribucion: new FormArray([]),
      idSprObjetivo: [],
      idSprAmbiente: [],
      nombre: ['', Validators.required],
      descripcion: [],
      idSprEnfoque: [''],
      idSprPerspectiva: [''],
      idSprEstrategia: [],
      fechaInicio: ['', Validators.required],
      fechaFin: ['', Validators.required],
      estado: ['', Validators.required]
    });
  }

  setFormAlineacionEs() {
    this.formEstrategia = this.fb.group({
      idSprEstrategiaObjetivo: [],
      //idSprEstrategia: [],
      idSprEstrategia: new FormArray([]),
      nivelSuperior: "S",
    });
  }




  listAmbiente() {
    this.ambienteService.list(`${this.idSprAmbiente}`)
      .subscribe(resp => {
        this.dataAmbiente = resp;
        this.listObjetivoNivelSuperior();
      })
  }

  listObjetivoNivelSuperior() { //nivel superior
    forkJoin([
      this.objetivosService.list('?idSprAmbiente=' + this.dataAmbiente.spr_idSprAmbiente +'&idSprPlanAnio=' + this.idSprPlanAnio),
      this.aniosObjetivosService.list('?idSprPlanAnio=' + this.idSprPlanAnio),
      this.estrategiaObjetivoService.list('?nivelSuperior=N'),
      this.estrategiasService.list(),
      this.ambienteService.getAmbienteId(this.dataAmbiente.spr_idSprAmbiente)
    ])
      .pipe(
        map(
          ([objNivelSuperior,dataPlanAnios,dataEstrategiasObjetivos,dataEstrategias,ambiente]) => {
            this.dataObjetivoNivelSuperior = objNivelSuperior;
            this.dataPlanAnios = dataPlanAnios;
            this.dataEstrategiaObjetivoMain = dataEstrategiasObjetivos;
           this.dataEstrategias = dataEstrategias; 
           this.ambienteNivelSuperior = ambiente;
          
             this.setMapeoAniosObjetivos();
          }
        )
      )
      .subscribe();
  }


  setMapeoAniosObjetivos(){
    let dataProcess: any = [];
    let ObjetivoTemp ='';
    let idSprObjetivoTemp ='';

          for (let i = 0; i < this.dataObjetivoNivelSuperior.length; i++) {
          for (let j = 0; j < this.dataEstrategiaObjetivoMain.length; j++) {

            if( this.dataObjetivoNivelSuperior[i].idSprObjetivo == this.dataEstrategiaObjetivoMain[j].idSprObjetivo){
            ObjetivoTemp =  this.dataObjetivoNivelSuperior[i].nombre;
            idSprObjetivoTemp =  this.dataObjetivoNivelSuperior[i].idSprObjetivo;
                        for (let k = 0; k < this.dataEstrategias.length; k++) {
                          if( this.dataEstrategias[k].idSprEstrategia == this.dataEstrategiaObjetivoMain[j].idSprEstrategia &&  this.dataEstrategiaObjetivoMain[j].nivelSuperior == 'N'){

                          dataProcess.push({
                              idSprEstrategia:this.dataEstrategias[k].idSprEstrategia,
                              nombre:this.dataEstrategias[k].nombre,
                          })
                        }

                      }
                    }

                  }
                  if(dataProcess.length > 0){
                    this.dataObjetivosAnios.push({
                    nombre:ObjetivoTemp,
                    idSprObjetivo:idSprObjetivoTemp,
                    estrategias: dataProcess
                  })
                  dataProcess =[];
                  }
          }
  }

  listEstrategiaObjetivoMain() {// consulta para el nivel superior

    for (let elemento of this.dataObjetivosAnios) {
      this.estrategiaObjetivoService.list('?idSprObjetivo=' + elemento.idSprObjetivo)
        .subscribe((resp) => {
          this.dataEstrategiaObjetivoMain = resp;
          let estrategiasobj1 = this.listEstrategiaNombre();
          elemento.estrategias = estrategiasobj1;
        });
    }
    return this.dataObjetivosAnios;
  }

  listEstrategiaNombre() {//nivel superir
    let estrategiasobj1 = [{}];
    let x = 0;
    for (let elemento of this.dataEstrategiaObjetivoMain) {
      this.estrategiasService.list(`${elemento.idSprEstrategia}`).subscribe((resp) => {
        estrategiasobj1[x] = {
          "idSprEstrategia": resp.idSprEstrategia,
          "nombre": resp.nombre
        };
        x = x + 1;
      });
    }
    x = 0;
    return estrategiasobj1
  }







  onChangeEstrategia(event: any) { //boton chekbox
    const idSprEstrategia = (this.formEstrategia.controls['idSprEstrategia'] as FormArray);
    if (event.target.checked) {
      idSprEstrategia.push(new FormControl(event.target.value));
    } else {
      this.estrategiasBorrar.push(event.target.value)
      const index = idSprEstrategia.controls
        .findIndex(x => x.value === event.target.value);
      idSprEstrategia.removeAt(index);
    }
  }
  onSubmitEstrategia(array: any[]) {
    this.submitted = true;
    this.formEstrategia.value.usuario = this.currentUser.idSprUsuario;
    this.formEstrategia.value.ip = this.ipAddress;
    array.forEach(element => {
      if (this.estrategiasBorrar.some(obj => +obj === element.idSprEstrategia)) {

        let elementToDelele = {
          ...element,
          delLog: 'S'
        }
        this.estrategiaObjetivoService.delete(elementToDelele).subscribe(
          resp => {
            this.deshabilitarEditar = true
          }
        )
      }
    })

    if (this.formEstrategia.value.idSprAtribucionObjetivo == null) {
      let estrategia = this.formEstrategia.value.idSprEstrategia;
      for (let elemento of estrategia) {
        let dataAtribuciones = {
          idSprObjetivo: this.idSprObjetivoA,
          idSprEstrategia: elemento,
          nivelSuperior: this.formEstrategia.value.nivelSuperior,
          usuario: this.currentUser.idSprUsuario,
          ip: this.ipAddress,
          estado: "1"
        }
        this.estrategiaObjetivoService.create(dataAtribuciones).subscribe(
          (resp) => {
            // this.initApp();
            //this.modal.close();
            this.deshabilitarEditar = true
            this.alert.createOk();
          },
          (err) => {
            this.alert.createError();
          }
        );
      }


    } else {
      this.estrategiaObjetivoService.update(this.formEstrategia.value).subscribe(
        (resp) => {
          //this.initApp();
          //this.modal.close();
          this.alert.updateOk();
        },
        (err) => {
          this.alert.updateError();
        }
      );
    }
  }

  openModalGestion() {
    this.onResetForm();
    //this.modal.open(this.nameModalGestion);
  }

  onResetForm() {
    this.submitted = false;
    this.formObjetivo.reset();
    //this.formEstrategia.reset();
  }

}
